import React from 'react'
import '../Assets/styles/preload.css'
const Preloader = () => {
  return (
    <>
        <div class="preload preload-container">
            <div id="loaders">
                <div id="shadow"></div>
                <div id="box"></div>
            </div>
        </div>
    </>
  )
}

export default Preloader